/** The class list every text-entry control shares. */
export const fieldSurface = [
  'bg-field-bg border-input text-foreground placeholder:text-placeholder',
  'shadow-inset focus-ring w-full rounded-md border',
  'disabled:opacity-50',
  // One source of truth for the error state: the attribute assistive technology
  // reads is the one the styling keys off.
  'aria-invalid:border-destructive aria-invalid:[--ring:var(--destructive)]',
] as const;
